import { ProfileUserResponse, UserResponse } from "@authory-packages/core";

export const getSearchFormattedSourcesOptions = (author: UserResponse | ProfileUserResponse, collectionSlug?: string) => {
    let sourcesToFilter = author.sources;

    if (collectionSlug) {
        const col = author.collections.find((col) => col.canonicalSlug === collectionSlug);

        // Filter out sources that dont have results if not godmode
        if (!("isGodMode" in author) || !author.isGodMode) {
            sourcesToFilter = sourcesToFilter.filter((source) => col?.sourcesCanonicalSlugs.find((src) => src === source.canonicalSlug));
        }
    }

    let formattedSourcesOptions = sourcesToFilter.map((source) => ({ value: source.canonicalSlug, text: source.publicationName || "" }));
    formattedSourcesOptions = [{ value: "", text: "All Sources" }, ...formattedSourcesOptions];

    return formattedSourcesOptions;
};
